<template>
  <div
    v-if="emphasis.length > 0"
    class="fixed top-0 left-0 bottom-0 right-0 w-full h-full z-50 pointer-events-none flex items-center justify-center bg-white/80"
    @click="emphasis = []"
  ></div>
</template>

<script setup lang="ts">
import { ref, watch } from "vue";

const emphasis = ref(
  new URLSearchParams(window.location.search).getAll("emphasis") || []
);

const DRAWER_CLASS_NAME = "@container/drawer";

const TOPNAV_OFFSET = 50;

// Add a z-index of 100 to the emphasis element
watch(
  emphasis,
  (emphasis) => {
    // Wait a bit.
    setTimeout(() => {
      document.querySelectorAll(`[data-emphasis-identifier]`).forEach((el) => {
        el.classList.remove("emphasized");
      });
      if (emphasis.length > 0) {
        emphasis.forEach((e) => {
          document
            .querySelectorAll(`[data-emphasis-identifier="${e}"]`)
            .forEach((el) => {
              el.classList.add("emphasized");
            });
        });
        // Grab first and last element.
        const firstElement = document.querySelectorAll(
          `[data-emphasis-identifier="${emphasis[0]}"]`
        )[0];
        const lastElement = document.querySelectorAll(
          `[data-emphasis-identifier="${emphasis[emphasis.length - 1]}"]`
        )[0];
        const firstOffset = firstElement.getBoundingClientRect().top;
        const lastOffset = lastElement.getBoundingClientRect().top;
        const midpoint = (firstOffset + lastOffset) / 2;

        // Calculate the destination scroll position such that the first element and the last element are equidistant from the top of the page
        // and the last element is at the bottom of the page.
        const pageHeight =
          document.getElementById("page-content")?.clientHeight || 0;
        const destination = midpoint - pageHeight / 2;

        // Find the right element to scroll to.
        const isInDrawer = document.querySelector(
          `.${CSS.escape(DRAWER_CLASS_NAME)}`
        );
        if (isInDrawer) {
          document
            .querySelector(`.${CSS.escape(DRAWER_CLASS_NAME)}`)
            ?.scrollTo({
              // We divide by two just to get a bit of space between the top nav and the first element.
              top: destination - TOPNAV_OFFSET / 2,
              behavior: "smooth",
            });
        } else {
          document.getElementById("page-content")?.scrollTo({
            // For non-drawer pages, we want to scroll to the destination, plus the height of the top nav.
            top: destination + TOPNAV_OFFSET,
            behavior: "smooth",
          });
        }
      }
    }, 500);
  },
  { immediate: true }
);
</script>

<style lang="scss">
.emphasized {
  z-index: 100 !important;
  border: 2px solid oklch(77.7% 0.152 181.912) !important;
  border-bottom: 0;
  box-sizing: border-box;
  padding: 8px !important;
  margin: -8px !important;
  border-radius: 8px 8px 0 0;
  animation: shadow-pulse 1s ease-in-out infinite;
  background-color: #fff;
  animation-delay: 0.5s;
  position: relative;

  ~ .emphasized {
    border-top-left-radius: 0 !important;
    border-top-right-radius: 0 !important;
    border-top: 0 !important;
    padding-top: 0 !important;
    margin-top: 8px !important;
  }

  &:not(:has(~ .emphasized)) {
    border-bottom: 2px solid oklch(77.7% 0.152 181.912) !important;
    border-bottom-left-radius: 8px !important;
    border-bottom-right-radius: 8px !important;
  }
}

// TanStack tables are weird.
.emphasized.place-items-center {
  padding: 0;
  margin: 0;
}
.bg-gray-900 .emphasized {
  background: #ffffff10;
  // We'll assume this is in a dropdown menu.
  margin: 0;
}
</style>
